import { Question, type QuestionKey, type RequirementField } from '@/entities/questionnaire';
import { Switch, Tooltip, Typography } from '@recruit-robin/robin-theme/web-components';

export type ReviewQuestionnaireQuestionWrapperProps = {
  question: RequirementField<unknown>;
  getQuestionText: (questionKey: QuestionKey, isAnswered?: boolean, unit?: string) => string;
  isRequired: boolean;
  onToggleRequired: (checked: boolean) => void;
  mustHaveLabel: string;
  niceToHaveLabel: string;
  tooltipLabel: string;
  children: React.ReactNode;
};

export function ReviewQuestionnaireQuestionWrapper({
  question,
  getQuestionText,
  isRequired,
  onToggleRequired,
  mustHaveLabel,
  niceToHaveLabel,
  tooltipLabel,
  children,
}: ReviewQuestionnaireQuestionWrapperProps) {
  return (
    <Question
      question={question}
      getQuestionText={getQuestionText}
      rightAdornment={
        <Tooltip
          label={<Typography variant={(v) => v.supporting.helper}>{tooltipLabel}</Typography>}
          placement="top"
          zIndex={5}>
          <Switch.Root checked={isRequired} onCheck={onToggleRequired}>
            <Switch.Label>
              <Typography variant={(v) => v.body.short}>{isRequired ? mustHaveLabel : niceToHaveLabel}</Typography>
            </Switch.Label>
            <Switch.Track />
          </Switch.Root>
        </Tooltip>
      }>
      {children}
    </Question>
  );
}
